import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Link } from "react-router-dom";
const Anchor = styled.a``;

const FooterElement = styled.footer`
    margin-top: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 3;

    background: var(--color-gray-200);
    @media (max-width: 768px){
        justify-content:center;
    }

`;

const Divider = styled.div`
    display: flex;
    width: calc(100% - (2*var(--app-horizontal-padding)));
    grid-column-start: 1;
    grid-column-end: 6;
    height: 1px;
    margin-left: var(--app-horizontal-padding);
    margin-right: var(--app-horizontal-padding);
    margin-top: var(--space-16);
    background-color:var(--color-gray-300);
    overflow: hidden;

    @media (max-width: 500px){
        display:none;
    }

`;

const SocialButtons = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 3rem;
    width: 3rem;
    border-radius: 3rem;
    background-color: var(--color-white);
    box-shadow: inset 0 0 0 0.5px var(--color-gray-300);

    @media (max-width: 800px){
        width: 2.2rem;
        height: 2.2rem;
       
    }
    @media (max-width: 500px){
        width: 3rem;
        height: 3rem;
       
    }
`;

const Copyright = styled.span`
    text-align: right;
    margin-right: var(--app-horizontal-padding);
    color: var(--color-gray-500);

    @media (max-width: 800px){
        position:relative;
       
    }
    @media (max-width: 500px){
        display:none;
    }
`;

const Legal = styled.div`
    margin-left: var(--app-horizontal-padding);
    a {
        margin-right: var(--space-20);
        color: var(--color-gray-600); 
    }
`;

const FooterLegal = styled.div`
    display: flex;
    justify-content: space-between;
    grid-column-start: 1;
    grid-column-end: 5;

    @media (max-width: 500px){
        display:none;
        
    }
`;

const FooterColumn = styled.div`
    display: flex;
    flex-direction: column;
    .social {
        display: flex;
        flex-direction: row;
        > a {
            margin-right: var(--space-16);
            &:last-of-type {
                margin-right: none;
            }
        }
    }
    .footer--logo {
        margin-bottom: var(--space-16);
    }
    .left-spacing {
        margin-left: var(--app-horizontal-padding);
    }
    :not(:first-of-type) {
        justify-self: end;
    }
    @media (max-width: 800px){
        .social{
            
            /* justify-content: space-between; */
        }
        .footer--logo{
            /* width: 10rem; */
        }
        .left-spacing{
            margin-left:0rem;
        }
    }
    @media (max-width: 500px){
        position:relative;
        /* right:5rem; */
        left: 0;
        .footer--logo{
            /* width: 6rem; */
        }
        :nth-of-type(1){
            padding-bottom:2rem;
            
        }
        :nth-of-type(2){
            position:relative;
            right:2rem;
            padding-bottom:2rem;
        }
        :nth-of-type(3){
            position:relative;
            right:2.5rem;
            padding-bottom:2rem;
        }
        :nth-of-type(4){
            position:relative;
            right:5rem;
            padding-bottom:2rem;
        }
        .left-spacing{
            /* margin-left:0rem; */
        }
        display: flex;
        /* grid-auto-flow:row; */
      
       
    }
`;

const ColumnHeader = styled.span`
    font-size: var(--font-18);
    font-weight: 500;
    color: var(--color-gray-800);
    padding-bottom: var(--space-32);
`;

const ColumnLine = styled.span`
    display: flex;
    align-items: center;
    margin-bottom: var(--space-16);
    a {
        display: flex;
        align-items: center;
        img {
            margin-right: var(--space-12);
        }
    }
`;

const FooterWrapper = styled.div`
    display: grid;
    margin: 0 auto;
    width: 100%;
    grid-template-columns: 2fr 1fr 1fr 1fr var(--app-horizontal-width);
    grid-gap: var(--space-24);
    padding-top: var(--space-64);
    padding-bottom: var(--space-48); 

    .mobile-divider{
        display:none;
    }


    @media (max-width: 800px){
       
        transform: scale(0.9);
    }
    @media (max-width: 500px){
        transform: none;
        justify-content:center;
        /* grid-template-columns: 10rem;
        grid-template-rows: 2fr 2fr 1fr 1fr var(--app-horizontal-width); */
        display: flex;
        flex-direction: column;
        align-items: center;

        .mobile-divider{
            display:block;
            position:relative;
            /* right:6.5rem; */
            width: 90vw;
            height: 0rem;
    
            border: 1px solid #D3D9DE;
        }
    }
`;

const FooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: auto;
    width: 100%;
    max-width: var(--app-max-width);
    white-space: nowrap;

    background-color: var(--color-gray-200);

    a {
        color: var(--color-gray-800);
    }
    
`;

const MobileLegal = styled.div`

    display:none;
    @media only screen and (max-width: 500px) {
        padding-top:2rem;
        display:flex;
        flex-direction:column;
        width: 90vw;
        align-items: center;
    }
    .legal{
        padding-top:1rem;
        display:flex;
        flex-direction:row;
        font-size:var(--font-12);
        font-weight:500;
        font-family:Inter,sans-serif;
        color:var(--color-gray-600);

    }
   
    span{
        position:relative;
        /* right:4.8rem; */
        font-size:var(--font-14);
        font-family:Inter,sans-serif;
        color:var(--color-gray-600);
    }
`;

export function Footer() {

    return (
        <FooterElement>
            <FooterContainer>
                <FooterWrapper>
                    <FooterColumn>
                        <img className="footer--logo left-spacing" alt='brand' src="/footer/irad-logo.svg" width="207px" />
                        <div className="social left-spacing">
                            <SocialButtons>
                                <img src="/img/svg/twitter.svg" alt="twitter" />
                            </SocialButtons>
                            <SocialButtons>
                                <img src="/img/svg/youtube.svg" alt="youtube" />
                            </SocialButtons>
                            <SocialButtons>
                                <img src="/img/svg/facebook.svg" alt="facebook" />
                            </SocialButtons>
                        </div>
                    </FooterColumn>
                    <FooterColumn className="contact">
                        <ColumnHeader>
                            Contact Us
                        </ColumnHeader>
                        {/* <ColumnLine>
                            <a href="tel: +18764817535"><img src="/img/svg/phone.svg" alt="phone" />876-481-7535</a>
                        </ColumnLine> */}
                        <ColumnLine>
                            <a href="tel: +18767547688"><img src="/img/svg/phone.svg" alt="phone" />876-754-7688</a>
                        </ColumnLine>
                        <ColumnLine>
                            <a href="https://api.whatsapp.com/send?phone=+18764817535"><img src="/img/svg/whatsapp.svg" alt="whatsapp" />876-481-7535</a>
                        </ColumnLine>
                        <ColumnLine>
                            <a href="mailto: orders@iradjamaica.com"><img src="/img/svg/email.svg" alt="email" />orders@iradjamaica.com</a>
                        </ColumnLine>
                    </FooterColumn>
                    <FooterColumn className="finder">
                        <ColumnHeader>
                            Find Us
                            </ColumnHeader>
                        <ColumnLine>
                            28 Half Way Tree Road
                            </ColumnLine>
                        <ColumnLine>
                            Kingston 5
                            </ColumnLine>
                    </FooterColumn>
                    {/* <FooterColumn>
                        <ColumnHeader>
                            About Us
                        </ColumnHeader>
                        <ColumnLine>
                            <Link to={"/products"}>Our Products</Link>
                        </ColumnLine>
                        <ColumnLine>
                        <Link to={"/about"}>About IRAD</Link>
                        </ColumnLine>
                        <ColumnLine>
                        <Link to={"/about"}>Medical Professionals</Link>
                        </ColumnLine>
                        <ColumnLine>
                        <Link to={"/contact"}>Send us a Message</Link>
                        </ColumnLine>
                    </FooterColumn> */}
                    <Divider />
                    <div className="mobile-divider"></div>
                    <FooterLegal>
                        <Legal>
                            <Link to={"/terms-of-use"}>
                                Terms of Use
                            </Link>
                            <Link to={"/privacy-policy"}>
                                Privacy Policy
                            </Link>
                        </Legal>
                        <Copyright>
                            Copyright © 1998-2021 IRAD, All Rights Reserved.
                        </Copyright>
                    </FooterLegal>

                    <MobileLegal>
                        <span>Copyright © 1998-2021 IRAD, All Rights Reserved.</span>
                        <div className="legal">
                            <Link to={"/terms-of-use"}>
                                Terms of Use
                                </Link>
                            <Link to={"/privacy-policy"} style={{ paddingLeft: "2rem" }}>
                                Privacy Policy
                                </Link>
                        </div>

                    </MobileLegal>

                </FooterWrapper>
            </FooterContainer>
        </FooterElement>
    );
}
